<app-floorplan-custom-part-numbers [floorplanItem]="alarmDevice()"></app-floorplan-custom-part-numbers>
